<div
  class="faultReporting"
  *appHasPermission="{
    permissions: [permissions.allPermissions.FAULT_REPORTING_READ, permissions.allPermissions.ASSET_HIERARCHY_READ],
    needsAllPermissions: true,
  }"
>
  <app-asset-hierarchy (assetClicked)="onAssetClicked($event)"> </app-asset-hierarchy>

  <div class="widget gap-2 flex flex-column container faultReportingList p-3">
    @if (timeOut()) {
      <app-timeout></app-timeout>
    } @else if (loading()) {
      <div class="flex justify-content-center align-items-center h-full">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else {
      @if (filteredFaultReportingData()) {
        <div class="flex justify-content-between align-items-start p-3">
          <app-svg-icon
            *appHasPermission="{
              permissions: [permissions.allPermissions.FAULT_REPORTING_EXPORT],
            }"
            class="pointer"
            [iconName]="'export'"
            [iconColor]="'primary'"
            (click)="onExportClick()"
            [pTooltip]="translate.instant('fault_reporting.export')"
            tooltipPosition="left"
          ></app-svg-icon>
        </div>

        <p-table
          [scrollable]="true"
          scrollHeight="flex"
          [rows]="paginatorOptions.DEFAULT_ROWS"
          [columns]="COLUMNS"
          [value]="filteredFaultReportingData()"
          [style]="{ flex: 1, 'min-height': 0 }"
          class="fullTable tableHeaderAlignTop p-3"
          [sortField]="currSort.column"
          [sortOrder]="currSort.order"
          [lazy]="true"
          (onLazyLoad)="loadMoreGateFaults($event)"
          [lazyLoadOnInit]="false"
          [virtualScroll]="true"
          [virtualScrollItemSize]="71"
          [virtualScrollDelay]="0"
          [virtualScrollOptions]="{ trackBy: trackByAlarmId }"
          [totalRecords]="totalFaultRecords"
        >
          <ng-template #header let-columns>
            <tr>
              @for (col of columns; track col) {
                <th
                  [ngClass]="{ wide: col.field === 'faultType' }"
                  style="padding: 0 12px 17px 12px"
                  [pSortableColumn]="col.field"
                >
                  <div class="headerContainer">
                    {{ col.header | translate }}
                    <p-sortIcon [field]="col.field" />
                  </div>
                </th>
              }
            </tr>
          </ng-template>
          <ng-template #body let-rowData let-columns="columns">
            <tr>
              @for (col of columns; track col) {
                <td>
                  @if (
                    (col.field === "triggeredAt" || col.field === "clearedAt" || col.field === "updatedAt") &&
                    rowData[col.field]
                  ) {
                    {{ convertTime(rowData[col.field]) }}
                  } @else if (col.field === "gateSystem") {
                    <span
                      class="cursorDefault"
                      [pTooltip]="
                        rowData.gateSystem
                          | gateIdentifier
                            : permissions.hasPermission(permissions.allPermissions.ASSET_MASTER_DATA_CREATE)
                      "
                    >
                      {{ rowData[col.field].label }} ...
                    </span>
                  } @else if (col.field === "faultText") {
                    <div class="clip-text" [pTooltip]="rowData[col.field]" tooltipPosition="left">
                      {{ rowData[col.field] }}
                    </div>
                  } @else {
                    {{ rowData[col.field] | translate }}
                  }
                </td>
              }
            </tr>
          </ng-template>
        </p-table>
      }
    }
  </div>
</div>
